<script lang="ts">
/**
 * Scalar dropdown divider component
 *
 * Used to create a divider between items in the ScalarDropdown component
 *
 * @example
 * <ScalarDropdown>
 *   ...
 *   <template #items>
 *     <ScalarDropdownItem>Item 1</ScalarDropdownItem>
 *     <ScalarDropdownItem>Item 2</ScalarDropdownItem>
 *     <ScalarDropdownDivider />
 *     <ScalarDropdownItem>Item 3</ScalarDropdownItem>
 *   </template>
 * </ScalarDropdown>
 */
export default {}
</script>
<template>
  <div class="-mx-0.75 my-0.75 h-border bg-border" />
</template>
